import { Button } from '@/components/shadcn/button'
import { IconV2AlertOutline } from '@icons/IconV2AlertOutline'

type WarningBannerProps = {
  message: string
  actionLabel?: string
  onAction?: () => void
}

export function WarningBanner({ message, actionLabel, onAction }: WarningBannerProps) {
  return (
    <div className="flex items-center gap-3 rounded-md border border-tangarine-300 bg-tangarine-50 px-3 py-2 text-sm text-tangarine-500 shadow-sm">
      <IconV2AlertOutline className="size-5 shrink-0" />
      <div className="min-w-0 flex-1">{message}</div>
      {actionLabel && onAction && (
        <Button size="sm" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </div>
  )
}
